import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from '@react-aria/utils';
import { createContext, useMemo, useState } from 'react';
export const DialogContext = createContext(undefined);
export const DialogContextProvider = ({ children }) => {
    const [footerRef, setFooterRef] = useState();
    const [headerRef, setHeaderRef] = useState();
    const [dialogRef, setDialogRef] = useState();
    const uniqueId = useId();
    const dialogId = `dialog-${uniqueId}`;
    const providerValue = useMemo(() => {
        return {
            bodyId: `${dialogId}-body`,
            footerRef,
            headerRef,
            dialogId,
            dialogRef,
            setFooterRef,
            setHeaderRef,
            setDialogRef,
            titleId: `${dialogId}-title`,
        };
    }, [footerRef, headerRef, dialogId, dialogRef, setFooterRef, setHeaderRef, setDialogRef]);
    return _jsx(DialogContext.Provider, { value: providerValue, children: children });
};
//# sourceMappingURL=DialogContextProvider.js.map